import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    useOrderAvailableDates,
    useOrderIsSyncingTimeSlots,
    useOrderLocation,
    useOrderMethod,
} from '@/hooks/api/order';

import OrderExpectedAtLabel from './OrderExpectedAtLabel';
import OrderDatePicker from './OrderDatePicker';
import OrderTimePicker from './OrderTimePicker';
import OrderDateLabel from './OrderDateLabel';
import OrderTimeLabel from './OrderTimeLabel';

const OrderDateTime = () => {
    const [t] = useTranslation('order.datetime');
    const available_dates = useOrderAvailableDates();
    const is_syncing = useOrderIsSyncingTimeSlots();
    const location = useOrderLocation();
    const method = useOrderMethod();

    if (!location || !method) {
        return null;
    }

    if (available_dates.length === 0 && !is_syncing) {
        return (
            <div className="m2g-alert m2g-alert--warning m2g-order-datetime-closed-alert">
                <span className="m2g-alert-icon m2g-alert-icon--large m2g-icon m2g-icon--alert m2g-order-datetime-closed-alert-icon" />
                <div className="m2g-alert-content m2g-order-datetime-closed-alert-content">
                    <strong>{t('store_is_closed')}</strong>
                    <br />
                    <span className="m2g-text--small">
                        {t('come_back_later')}
                    </span>
                </div>
            </div>
        );
    }

    return (
        <>
            <OrderExpectedAtLabel />
            <OrderDatePicker />
            <OrderTimePicker />
            <OrderDateLabel />
            <OrderTimeLabel />
        </>
    );
};

export default OrderDateTime;
